module.exports = __webpack_public_path__ + "img/TITLE.c7bd9c0a.png";